import styled from "styled-components"

export const BoxPlus = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.padding.km4};
  background-color: ${({ theme }) => theme.color.background.neutral.weak};
  border-radius: ${({ theme }) => theme.border.radius.default};

  span {
    display: flex;

    img {
      position: absolute;
      top: 12px;
      left: 10px;
    }
  }
`
